/// <amd-module name="TFS/Views/ProjectOverviewPage/Shared/ProjectMembersActionCreator" />
import { ActionsHub } from "TFS/Views/ProjectOverviewPage/Actions/ActionsHub";
import * as ProjectOverviewResources from "TFS/Views/ProjectOverviewPage/Resources";
import { MembersData } from "TFS/Views/ProjectOverviewPage/Shared/Models";
import { ProjectMembersSource } from "TFS/Views/ProjectOverviewPage/Shared/ProjectMembersSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class ProjectMembersActionCreator {
    constructor(private _pageContext: IVssPageContext, private _actions: ActionsHub, private _projectMembersSource?: ProjectMembersSource) {}

    public fetchProjectMembers(forceRefresh?: boolean): void {
        this.projectMembersSource.getProjectMembers(forceRefresh).then(
            (members: MembersData | undefined) => {
                if (members) {
                    this._actions.projectMembersFetched.invoke(members);
                } else {
                    this._invokeProjectMembersFetchFailed();
                }
            },
            (error: Error) => {
                this._invokeProjectMembersFetchFailed(error);
            }
        );
    }

    private _invokeProjectMembersFetchFailed(error?: Error): void {
        const message = !!error ? error.toString() : ProjectOverviewResources.ProjectMembers_ErrorLoadingMembers;
        this._actions.projectMembersFetchFailed.invoke(message);
    }

    private get projectMembersSource(): ProjectMembersSource {
        if (!this._projectMembersSource) {
            this._projectMembersSource = new ProjectMembersSource(this._pageContext);
        }

        return this._projectMembersSource;
    }
}
